module.exports = __webpack_public_path__ + "static/media/al.a8f8b9db.svg";